import { Header } from '@rbilabs/universal-components';

export const Heading = Header.withConfig({
  variant: 'headerOne',
  textAlign: 'center',
  fontSize: {
    base: '2xl',
    md: '4xl',
  },
  marginTop: {
    base: 4,
    md: 12,
  },
  marginBottom: 0,
  fontWeight: 'normal',
  textTransform: 'none',
});
